import { TheMask } from 'vue-the-mask'

export default {
  TheMask
}



// WEBPACK FOOTER //
// ./src/app/dweller/rental/resources/components.js